import { computed, ref, toValue, watch } from 'vue';
import { getSportLiveTvStreamLink } from '@/api/sport-live-tv';
import { useAsyncData } from '@/composables/use-async-data';

export const useSportLiveTvStream = (event) => {
  const selectedEpgId = ref('');

  const sources = computed(() => toValue(event)?.available_on_epg_ids ?? []);
  const epgId = computed(() => selectedEpgId.value || (sources.value.length === 1 ? sources.value[0].epgId : ''));

  const streamLink = useAsyncData(() => getSportLiveTvStreamLink(epgId.value), { immediate: false });

  watch(
    epgId,
    (value) => {
      if (value) {
        streamLink.execute();
      } else {
        streamLink.reset();
      }
    },
    { immediate: true }
  );

  const selectStream = (value) => {
    selectedEpgId.value = value;
  };

  const refetch = () => {
    if (epgId.value) streamLink.execute();
  };

  return {
    sources,
    streamUrl: streamLink.data,
    selectStream,
    needsChoice: computed(() => !epgId.value && sources.value.length > 1),
    hasNoSources: computed(() => Boolean(toValue(event)) && !sources.value.length),
    isLoading: computed(() => Boolean(epgId.value) && streamLink.isLoading.value),
    isError: streamLink.isError,
    refetch,
  };
};
